import module from 'facturacion/facturas/module.js'
import template from './template.html'

export class FacturacionFacturasMasivoConfirmar {
  timbres
  onClose

  constructor (FacturacionComprobanteIngreso) {
    this.FacturacionComprobanteIngreso = FacturacionComprobanteIngreso
  }

  $onInit () {
    this.procesar = this.timbres.filter((item) => !item.timbrado)
  }

  timbrarInicio () {
    this.contador = 0
    this.progreso = 0
    this.procesando = true
    this.procesar = this.timbres.filter((item) => !item.timbrado)
    this.timbrar()
  }

  timbrar () {
    if (this.contador === this.procesar.length) {
      this.finalizar()
      return
    }

    let data = this.procesar[this.contador]

    if (!data.timbrado) {
      this.FacturacionComprobanteIngreso.post(data)
        .then(() => (this.procesar[this.contador].timbrado = true))
        .catch((response) => (this.procesar[this.contador].error = response.data || response))
        .finally(() => (this.contador++))
        .finally(() => (this.timbrar()))
        .finally(() => {
          this.progreso = (this.contador / this.procesar.length)
          this.timbradas = this.timbres.filter(item => item.timbrado).length
          this.erroneas = this.timbres.filter(item => !item.timbrado && item.error).length
        })
    } else {
      this.contador++
      this.timbrar()
    }
  }

  finalizar () {
    this.procesando = false
    this.reintentar = this.timbres.some(item => item.error && !item.timbrado)
    this.procesado = !this.reintentar
    this.timbres = [...this.timbres]
  }

  cerrar () {
    this.onClose()
  }
}

module.component('facturacionFacturasMasivoConfirmar', {
  controller: FacturacionFacturasMasivoConfirmar,
  template,
  bindings: {
    timbres: '<',
    idEmpresa: '<',
    fecha: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/facturacion/facturas/components/ingreso/masivo/confirmar/component.js